import { render, staticRenderFns } from "./customInput.vue?vue&type=template&id=18667de3"
import script from "./customInput.vue?vue&type=script&lang=js"
export * from "./customInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports